import React, { FC } from 'react';
import PropertyDisplay from '../../../components/PropertyDisplay/PropertyDisplay';
import { useReferenceData } from '../../../hooks/reduxHooks';
import { formatCurrency } from '../../../utils/currencyUtils';
import { displayString } from '../../../utils/stringUtils';

interface ComponentPropertiesProps {
	componentData: {
		component?: Pick<
			ProductComponentData,
			| 'bundle_type'
			| 'code_in_box_ready'
			| 'content_type'
			| 'expected_rom_band'
			| 'game_code'
			| 'game_name'
			| 'item_code'
			| 'ns_uid'
			| 'product_type'
			| 'retail_prices'
		>;
		product?: {
			company_name: string;
			name: string;
			game_code: string;
		},
		wholesale_price_requests?: Required<CIBPriceRequestData>[];
	};
	compact?: boolean;
}
const ComponentProperties: FC<ComponentPropertiesProps> = ({ componentData, compact }) => {
	const platforms = useReferenceData('platforms');
	const { product, component } = componentData;

	return (
		<>
			<PropertyDisplay label="Publisher" compact={compact}>
				{product?.company_name}
			</PropertyDisplay>
			<PropertyDisplay label="Product" compact={compact}>
				{product?.name} ({product?.game_code})
			</PropertyDisplay>
			<PropertyDisplay label="Component Name" compact={compact}>
				{component?.game_name || <>&mdash;</>}
			</PropertyDisplay>
			<PropertyDisplay label="NSUID" compact={compact}>
				{component?.ns_uid || <>&mdash;</>}
			</PropertyDisplay>
			<PropertyDisplay label="Component Game Code" compact={compact}>
				{component?.game_code || <>&mdash;</>}
			</PropertyDisplay>
			<PropertyDisplay label="Component Item Code" compact={compact}>
				{component?.item_code || <>&mdash;</>}
			</PropertyDisplay>
			<PropertyDisplay label="Product Type" compact={compact}>
				{(component?.product_type &&
					platforms?.find(
						({ platform_code }) => component?.product_type === platform_code,
					)?.platform_name) ?? <>&mdash;</>}
			</PropertyDisplay>
			<PropertyDisplay label="Content Type" compact={compact}>
				{component?.content_type ? displayString(component?.content_type) : <>&mdash;</>}
			</PropertyDisplay>
			<PropertyDisplay label="Bundle Type" compact={compact}>
				{component?.bundle_type ? displayString(component?.bundle_type) : <>&mdash;</>}
			</PropertyDisplay>
			<PropertyDisplay label="Retail Price" compact={compact}>
				{(Number(component?.retail_prices?.length) > 1
					? 'Duplicate'
					: component?.retail_prices?.[0]?.price != null
					? formatCurrency(component?.retail_prices?.[0]?.price)
					: null) || <>&mdash;</>}
			</PropertyDisplay>
		</>
	);
};

export default ComponentProperties;
